import React from "react";

import { Icon } from "@iconify/react";
import { ExternalLinkIcon, ShareIcon } from "lucide-react";
import { Button } from "js/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "js/components/ui/dialog";
import { CopyButton } from "js/components/ui/copy-button";

interface ShareReportModalProps {
  open: boolean;
  tenantPhoneNumber: string;
  landlordPhoneNumber?: string;
  guarantorPhoneNumber?: string;
  reportUrl: string;
  multiexpedienteUrl?: string;
  setShareReportModalIsOpen: (value: boolean) => void;
}

const ShareReportModal: React.FC<ShareReportModalProps> = ({
  open,
  reportUrl,
  multiexpedienteUrl,
  tenantPhoneNumber,
  landlordPhoneNumber,
  guarantorPhoneNumber,
  setShareReportModalIsOpen,
}) => {
  const whatsAppMessage = multiexpedienteUrl
    ? `Hola! Te comparto el enlace donde podrás cargar los documentos necesarios para la solicitud de renta: ${multiexpedienteUrl} Si tienes alguna duda, no dudes en contactarme.`
    : `Hola! Te comparto el enlace para realizar el pago de la solicitud de renta: ${reportUrl} . Si tienes alguna duda, estoy a tu disposición.`;

  const phoneNumbers = [
    { label: "Inquilino", number: tenantPhoneNumber },
    { label: "Propietario", number: landlordPhoneNumber },
    { label: "Fiador / O.S", number: guarantorPhoneNumber },
  ];

  const shareUrl = multiexpedienteUrl || reportUrl;

  return (
    <Dialog open={open} onOpenChange={setShareReportModalIsOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShareIcon className="size-4" />
            Compartir
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {reportUrl && (
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">URL:</p>
              <div className="flex items-center justify-center gap-3">
                <div className="flex items-center gap-1">
                  <span className="text-sm">
                    {multiexpedienteUrl ? "Copiar URL" : "Copiar URL del pago"}
                  </span>
                  <CopyButton value={shareUrl} />
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => window.open(shareUrl, "_blank")}
                >
                  <ExternalLinkIcon className="size-4" />
                  {multiexpedienteUrl ? "Ir a la solicitud" : "Ir al pago"}
                </Button>
              </div>
            </div>
          )}

          <div className="space-y-2">
            <p className="text-sm text-muted-foreground">
              Compartir por WhatsApp:
            </p>
            <div className="flex flex-wrap justify-center gap-2">
              {phoneNumbers.map(
                ({ label, number }) =>
                  number && (
                    <Button
                      key={label}
                      variant="outline"
                      className="border-green-300 text-green-700 hover:bg-green-50"
                      onClick={() =>
                        window.open(
                          `https://wa.me/${number}?text=${encodeURIComponent(whatsAppMessage)}`,
                          "_blank",
                          "noopener,noreferrer",
                        )
                      }
                    >
                      <Icon icon="ic:baseline-whatsapp" fontSize={20} />
                      {label}
                    </Button>
                  ),
              )}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareReportModal;
